export enum BillingReportStatus {
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  ERRORED = 'ERRORED',
}

export const BILLING_REPORT_STATUS_LABELS: Record<BillingReportStatus, string> = {
  [BillingReportStatus.PROCESSING]: 'Generando',
  [BillingReportStatus.COMPLETED]: 'Listo',
  [BillingReportStatus.ERRORED]: 'Error',
};

export interface BillingReport {
  id: string;
  periodStart: string;
  periodEnd: string;
  status: BillingReportStatus;
  fileName: string;
  rowCount: number | null;
  startedAt: string | null;
  finishedAt: string | null;
}

export interface BillingReportListResponse {
  count: number;
  items: BillingReport[];
}
